<template>
    <section class="desktop-nav">
        <div class="desktop-nav__top">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <desktop-navigation-type :navigation="navigation"></desktop-navigation-type>
                    </div>
                </div>
            </div>
        </div>
        <div class="desktop-nav__main">
            <search-panel></search-panel>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="navbar">
                            <a href="/" class="navbar__brand">
                                <svgComponent
                                    :width="120"
                                    :height="120"
                                    class-name=" logo"
                                    icon-name="knhs-logo"></svgComponent>
                            </a>

                            <desktop-navigation
                                :navigation="navigation"
                                :secondary-nav="secondaryNav"></desktop-navigation>

                            <div class="navbar__controls">
                                <button
                                    @click="desktopNavStore.toggleSearchNav()"
                                    type="button"
                                    class="btn-rounded">
                                    <svgComponent
                                        :width="24"
                                        :height="24"
                                        class-name="icon-search"
                                        icon-name="icon-search"></svgComponent>
                                    <span>Zoeken</span>
                                </button>
                                <a
                                    class="btn-rounded"
                                    :href="knhsbutton.Url"
                                    :target="knhsbutton.Target">
                                    <svgComponent
                                        :width="24"
                                        :height="24"
                                        class-name="icon-person"
                                        icon-name="icon-person-nav"></svgComponent>
                                    <span>{{ knhsbutton.Text }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import svgComponent from '../../components/svgComponent.vue';
import searchPanel from './components/searchPanel.component.vue';

import { INavigation, ILink, IButtonLink, IPopularLink } from '../../interfaces/Navigation';
import desktopNavigation from './components/desktopNavigation.component.vue';
import desktopNavigationType from './components/desktopNavigationType.component.vue';
import { useDesktopNavStore } from './store/desktop-nav.store';

const props = defineProps<{
    navigation: INavigation[];
    navType: string;
    secondaryNav: ILink;
    knhsbutton: IButtonLink;
    contactbutton: IButtonLink;
    popularTopics?: IPopularLink[];
    popularKeywords?: string[];
}>();

const desktopNavStore = useDesktopNavStore();

if (props.popularKeywords) {
    desktopNavStore.setPopularKeywords(props.popularKeywords);
}
if (props.popularTopics) {
    desktopNavStore.setPopularTopics(props.popularTopics);
}

onMounted(() => {
    const type = props.navigation.find((x) => x.Active);
    let navType = 'Ruiter';

    if (type) {
        navType = type.Type;
    }

    desktopNavStore.setNavigationType(navType);
});
</script>
